
import "../../../Foundation/stylable/spacing.st.css.js";
import "../../../Foundation/stylable/colors.st.css.js";

import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_180_0_Field";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_180_0_Field__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-side-panel-control-layout-divider-border-width":"--wds-side-panel-control-layout-divider-border-width","wds-color-border-dark-secondary":"--wds-color-border-dark-secondary","wds-space-200":"--wds-space-200","wds-space-400":"--wds-space-400","wds-side-panel-field-padding-horizontal":"--wds-side-panel-field-padding-horizontal","wds-side-panel-field-padding-vertical":"--wds-side-panel-field-padding-vertical","border-width":"--wds_1_180_0_Field-border-width"}; 




